import React, { useContext, useEffect, useRef, useState } from "react";
import classes from "./VideoTestimonial.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Modal } from "antd";
import ReactPlayer from "react-player";
import { useLocation, useNavigate } from "react-router-dom";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import AdjustFontSize from "../../../components/adjust-font-size/AdjustFontSize";
import YouTube from "react-youtube"; // Import react-youtube
import { NavigationContext } from "../../../App";


const VideoTestimonial = ({ data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState();
  const swiperRef = useRef(null);
  const navigate = useNavigate();
  const [responsiveHtml, setResponsiveHtml] = useState("");
  const width = useDeviceWidth();
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [player, setPlayer] = useState(null); // Store player instance
  const divRef = useRef(null); // Create a ref for the div
  const [widthValue, setWidth] = useState(0);
  const { setIsBackNavigation } = useContext(NavigationContext);
  const location = useLocation();
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

  useEffect(() => {
    if (divRef.current) {
      setWidth(divRef.current.offsetWidth); // Get the width of the div
    }

    // Optional: Update width on window resize
    const handleResize = () => {
      if (divRef.current) {
        setWidth(divRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    //html content will rearrange fontsize when window width changes
    if (data) {
      setResponsiveHtml(AdjustFontSize(data?.description, width));
    }
  }, [data, width]);

  const getYouTubeThumbnail = (url) => {
    const videoIdMatch = url.match(
      /(?:https?:\/\/(?:www\.)?youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|(?:https?:\/\/)?(?:www\.)?youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );
    return videoIdMatch
      ? `https://img.youtube.com/vi/${videoIdMatch[1]}/hqdefault.jpg`
      : null;
  };

  // const showModal = (videoUrl) => {
  //   setIsModalOpen(true);
  //   setVideoUrl(videoUrl);
  // };
  const handleCancel = () => {
    if (player) player.stopVideo(); // Stop video playback
    setIsModalOpen(false);
    setSelectedVideo(null);
  };

  // Handle video selection
  const handleVideoClick = (url) => {
    setSelectedVideo(getVideoId(url));
    setIsModalOpen(true);
  };

  // YouTube Player options
  const opts = {
    height: "450",
    width: "100%",
    playerVars: {
      autoplay: 1, // Auto-play video when opened
    },
  };

  // Extract YouTube video ID
  const getVideoId = (url) => {
    const match =
      url.match(/[?&]v=([^&#]+)/) || url.match(/youtu\.be\/([^&#]+)/);
    return match ? match[1] : null;
  };

  return (
    <div className={classes.videoContainer}>
      <div
        className={classes.leftSection}
        data-aos="zoom-in"
        data-aos-delay="200"
      >
        <h3 className={classes.tag}>{data?.subTitle}</h3>
        {data?.showTitle && (
          <h2
            ref={divRef}
            className={classes.heading}
            dangerouslySetInnerHTML={{ __html: data?.title }}
          ></h2>
        )}
        <div className={classes.divideLine}></div>
        {data?.description && (
        <h4
          className={classes.paragraph}
          dangerouslySetInnerHTML={{ __html: responsiveHtml }}
        ></h4>
      )}
        <button
          className={`${classes.button} primaryHover`}
          onClick={() => {
            const yPos = window.scrollY;
              sessionStorage.setItem("scrollTargetY", yPos.toString());
              setIsBackNavigation(true)
              sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
            navigate(`/testimonials`)}}
        >
          Watch More Stories
        </button>
      </div>
      <div
        className={classes.rightSection}
        data-aos="fade-down"
        data-aos-delay="200"
      >
        <div
          className={classes.videoSliderContainer}
          onMouseEnter={() => swiperRef.current?.autoplay.stop()} // Stop autoplay on hover
          onMouseLeave={() => swiperRef.current?.autoplay.start()}
        >
          <Swiper
            modules={[Autoplay]}
            spaceBetween={10}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            slidesPerView={1}
            loop={true}
            // draggable={true} // Enable drag/swipe functionality
            // autoplay={{
            //   delay: 3000, // 3 seconds
            //   disableOnInteraction: false, // Autoplay continues even after interaction
            // }}
          >
            {data?.listingItems?.map((video) => (
              <>
                <SwiperSlide key={video.id}>
                  <div className={classes.videoSection}>
                    <div
                      className={classes.blurredBackground}
                      style={{
                        backgroundImage: `url(${getYouTubeThumbnail(
                          video?.videoUrl
                        )})`,
                        background: `linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7)), url(${getYouTubeThumbnail(
                          video?.videoUrl
                        )})`,
                      }}
                    ></div>
                    <img
                      alt="play button"
                      // onClick={() => showModal(video?.videoUrl)}
                      onClick={() => handleVideoClick(video?.videoUrl)}
                      src="/img/icons/playButton.svg"
                      className={classes.playButton}
                    />
                    <img
                      src={getYouTubeThumbnail(video?.videoUrl)}
                      alt="Video Thumbnail"
                      className={classes.mainImage}
                    />
                  </div>
                  {/* <video
                  src={video.src}
                  controls
                  style={{ width: "100%", borderRadius: "38px" }}
                /> */}
                </SwiperSlide>
              </>
            ))}
          </Swiper>
          <div className={classes.customNavigation}>
            <img
              className={classes.swiperButtonNextCustom}
              src="/img/doctor-right.svg"
              alt=""
              onClick={() => swiperRef.current?.slideNext()}
            />
            <img
              src="/img/doctor-left.svg"
              className={classes.swiperButtonPrevCustom}
              alt="doctor"
              onClick={() => swiperRef.current?.slidePrev()}
            />
            {/* <button className={classes.swiperButtonNextCustom}>Next</button>
            <button className={classes.swiperButtonPrevCustom}>Prev</button> */}
          </div>
        </div>
      </div>
      {/* <Modal
        centered
        className="video-modal"
        open={isModalOpen}
        onCancel={() => handleCancel()}
        footer={null}
        width={800}
      >
        <ReactPlayer
          url={videoUrl}
          playing={isModalOpen}
          controls
          width="100%"
          height="450px"
        />
      </Modal> */}
      <Modal
        // title="Video Player"
        open={isModalOpen}
        onCancel={handleCancel} // Stop video on close
        footer={null}
        width={800}
        centered
      >
        {selectedVideo && (
          <YouTube
            videoId={selectedVideo}
            opts={opts}
            onReady={(event) => setPlayer(event.target)} // Store player instance
          />
        )}
      </Modal>
    </div>
  );
};

export default VideoTestimonial;
